import {
  SET_ISSUE_UI_FLAG,
  CLEAR_ISSUES,
  SET_ISSUES,
  SET_ISSUE_ITEM,
  EDIT_ISSUE,
  DELETE_ISSUE,
} from './types';
import IssuesAPI from '../../../api/issues';

export const actions = {
  create: async ({ commit }, issueInfo) => {
    commit(SET_ISSUE_UI_FLAG, { isCreating: true });
    try {
      const response = await IssuesAPI.create(issueInfo);
      const issue = response.data;
      commit(SET_ISSUE_ITEM, issue);
      return issue;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_ISSUE_UI_FLAG, { isCreating: false });
    }
  },
  revalidate: async ({ commit }, { newKey }) => {
    try {
      const isExistingKeyValid = await IssuesAPI.validateCacheKey(newKey);
      if (!isExistingKeyValid) {
        const response = await IssuesAPI.refetchAndCommit(newKey);
        commit(SET_ISSUES, response.data);
      }
    } catch (error) {
      // Ignore error
    }
  },
  get: async ({ commit }) => {
    commit(SET_ISSUE_UI_FLAG, { isFetching: true });
    try {
      const { data } = await IssuesAPI.get(false);
      commit(CLEAR_ISSUES);
      commit(SET_ISSUES, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_ISSUE_UI_FLAG, { isFetching: false });
    }
  },

  show: async ({ commit }, { id }) => {
    commit(SET_ISSUE_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await IssuesAPI.show(id);
      commit(SET_ISSUE_ITEM, response.data.payload);
      commit(SET_ISSUE_UI_FLAG, {
        isFetchingItem: false,
      });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_ISSUE_UI_FLAG, {
        isFetchingItem: false,
      });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(SET_ISSUE_UI_FLAG, { isUpdating: true });
    try {
      const response = await IssuesAPI.update(id, updateObj);
      commit(EDIT_ISSUE, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_ISSUE_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, issueId) => {
    commit(SET_ISSUE_UI_FLAG, { isDeleting: true });
    try {
      await IssuesAPI.delete(issueId);
      commit(DELETE_ISSUE, issueId);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_ISSUE_UI_FLAG, { isDeleting: false });
    }
  },
};
